import { Link } from "react-router-dom";

// SEVRIC-styled 404. Reached when the user hits an unknown route inside
// the app. Inherits the brand wash from index.css; just lays out a panel.
export function NotFound() {
  return (
    <main className="container" style={{ paddingTop: 80 }}>
      <div className="panel" style={{ maxWidth: 480, margin: "0 auto", textAlign: "center" }}>
        <div className="eyebrow" style={{ justifyContent: "center" }}>404 · not found</div>
        <h1 className="display-title" style={{ fontSize: 36, marginTop: 14 }}>
          Page <em>not found</em>.
        </h1>
        <p style={{ marginTop: 12, color: "var(--text-muted)" }}>
          The route you tried to open doesn't exist in Battery Care.
          You can head back to the home page or to the SEVRIC portal.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 22 }}>
          <Link to="/today" className="btn">← Today</Link>
          <a href="https://portal.sevric.com" className="btn primary">SEVRIC portal</a>
        </div>
      </div>
    </main>
  );
}
